import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export const Error500Page = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-6 px-4">
        <h1 className="text-4xl font-bold text-primary">500</h1>
        <h2 className="text-2xl font-semibold text-foreground">Server Error</h2>
        <p className="text-muted-foreground max-w-md">
          Sorry, it looks like something went wrong. We're currently working to
          fix the issue.
        </p>
        <div className="space-x-4">
          <Button onClick={() => navigate('/')}>Reload</Button>
        </div>
      </div>
    </div>
  );
};
